module.exports = __webpack_public_path__ + "img/6.0d6af1c9.jpeg";